import { useMutacao } from './base';

/**
 * POST /marcas-revisao/:id/dispensar (`marca.dispensar`, 204): some a marca "custo atualizado - revisar preco" ate o sugerido
 * mudar de novo. Invalida a lista de precos e a formacao (que mostram a marca).
 */
export function useDispensarMarca() {
  return useMutacao<void, string>({
    metodo: 'POST',
    caminho: (id) => `/marcas-revisao/${id}/dispensar`,
    corpo: () => ({}),
    invalidar: [['precificacao'], ['marcas-revisao'], ['simulacao']],
  });
}

export interface FiltroDispensaLote {
  tabelaId?: string;
  variacaoMinPct?: number;
  variacaoMaxPct?: number;
  abaixoDoMinimo?: boolean;
  abaixoDaMeta?: boolean;
  motivo: string;
  confirmar: boolean;
  esperado?: number;
}

/**
 * POST /marcas-revisao/dispensar-lote (`marca.dispensar`): sem `confirmar` e a previa da contagem (nada grava); com `confirmar` e
 * `esperado` dispensa de uma vez. A contagem e feita no servidor (a faixa do praticado e calculada pelo motor).
 */
export function useDispensarMarcasLote() {
  return useMutacao<{ confirmado: boolean; total: number; restantes: number; naoAvaliadas: number }, FiltroDispensaLote>({
    metodo: 'POST',
    caminho: () => '/marcas-revisao/dispensar-lote',
    corpo: (v) => v,
    invalidar: [['precificacao'], ['marcas-revisao'], ['simulacao']],
  });
}
